import React from "react";
import CriticalImage from "@components/atoms/image/CriticalImage";

type heroImage = {
  path: string;
  alt: string;
};

type HeroProps = {
  data: {
    heading: string;
    desc: string;
    image?: heroImage;
    logo?: heroImage;
  };
};
export default function Hero({ data }: HeroProps) {
  return (
    <section className="container grid--wrap fx--sb has-align-top hero--default lg:pb-10 md:pb-5 md:pt-8">
      <article className="text-left lg:maxw-lg fx fx--c">
        <span className="apostrophe">&#8220;</span>
        <h1
          className="text-lg lg:maxw-md lg:mb-3"
          dangerouslySetInnerHTML={{ __html: data.heading }}
        />
        <p
          className="lg:maxw-md lg:mb-9 md:mb-5"
          dangerouslySetInnerHTML={{ __html: data.desc }}
        />
        <CriticalImage
          mobile="crop"
          dpi="@2x"
          wrapClass="customer-business-logo"
          src={data?.logo?.path}
          alt={data?.logo?.alt}
        />
      </article>
      <CriticalImage
        mobile="crop"
        dpi="@2x"
        imgClass="imgholder-secondary"
        wrapClass="lg:maxw-lg md:mt-5"
        src={data?.image?.path}
        alt={data?.image?.alt}
      />
      <style jsx>{`
        :global(.customer-business-logo img) {
          width: auto;
          height: 100%;
        }
      `}</style>
    </section>
  );
}
